import React, { Component, PropTypes } from 'react';

import {
  label as labelStyle,
  small as smallStyle,
  stars,
} from './styles.module.css';

/*
 * Star Rating Component.
 * Original npm package does not feature hover states, but this fork does.
 * See https://github.com/ronihcohen/react-star-rating-component/tree/mouse-hover-effect.
 * PR here: https://github.com/voronianski/react-star-rating-component/pull/23
 */

class StarRatingComponent extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    small: PropTypes.bool,
    value: PropTypes.number,
    editing: PropTypes.bool,
    onChange: PropTypes.func,
    className: PropTypes.string,
    starCount: PropTypes.number,
    starColor: PropTypes.string,
    onStarClick: PropTypes.func,
    renderStarIcon: PropTypes.func,
    renderStarIconHalf: PropTypes.func,
  };

  static defaultProps = {
    onChange: undefined,
    onStarClick: undefined,
    renderStarIcon: undefined,
    renderStarIconHalf: undefined,
  }

  static defaultProps = {
    small: false,
    className: '',
    starCount: 5,
    value: null,
    editing: true,
    starColor: '#ffb400',
    emptyStarColor: '#333',
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };
  }


  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;

    if (value != null && (value !== this.state.value)) {
      this.setState({ value });
    }
  }

  onChange(value) {
    const { editing } = this.props;

    if (!editing) {
      return;
    }

    this.setState({ value });
  }

  onStarClick(index, value, name) {
    const { onStarClick, editing } = this.props;

    if (!editing) {
      return;
    }

    onStarClick && onStarClick(index, value, name);
  }

  onStarOverOrLeave(index) {
    this.setState({ hover: index });
  }

  renderStars() {
    const { name, starCount, starColor, emptyStarColor, editing } = this.props;
    let { value, hover } = this.state;

    if (hover && editing) {
      value = hover;
    }

    const starStyles = (i, value) => ({
      float: 'right',
      cursor: editing ? 'pointer' : 'default',
    });

    const radioStyles = {
      display: 'none',
      position: 'absolute',
      marginLeft: -9999,
    };

    // populate stars
    const starNodes = [];

    for (let i = starCount; i > 0; i--) {
      const id = `${name}_${i}`;
      const starNodeInput = (
        <input
          key={`input_${id}`}
          style={radioStyles}
          className="dv-star-rating-input"
          type="radio"
          name={name}
          id={id}
          value={i}
          checked={value === i}
          /*
           * Needed to change the onChange prop here to this.props.onChange
           * to use higher order component's onChange function instead.
           */
          onChange={this.props.onChange}
          onClick={this.onChange.bind(this, i, name)}
        />
      );
      const starNodeLabel = (
        <label
          key={`label_${id}`}
          style={starStyles(i, value)}
          className={this.props.small ? smallStyle : labelStyle}
          htmlFor={id}
          onClick={this.onStarClick.bind(this, i, value, name)}
          onMouseOver={this.onStarOverOrLeave.bind(this, i)}
          onMouseLeave={this.onStarOverOrLeave.bind(this, null)}
        >
          {this.renderIcon(i, value, name)}
        </label>
      );

      starNodes.push(starNodeInput);
      starNodes.push(starNodeLabel);
    }

    return starNodes;
  }

  renderIcon(index, value, name) {
    const { renderStarIcon, renderStarIconHalf } = this.props;

    if (
      typeof renderStarIconHalf === 'function' &&
      Math.ceil(value) === index &&
      value % 1 !== 0
    ) {
      return renderStarIconHalf(index, value, name);
    }

    if (typeof renderStarIcon === 'function') {
      return renderStarIcon(index, value, name);
    }

    return <i style={{ fontStyle: 'normal' }}>&#9733;</i>;
  }

  render() {
    const { editing, className } = this.props;
    const classes = ['dv-star-rating', !editing ? 'dv-star-rating-non-editable' : '', className, this.props.small ? '' : stars];

    return (
      <div style={{ display: 'inline-block', position: 'relative' }} className={classes.join(' ')}>
        {this.renderStars()}
      </div>
    );
  }
}

export default StarRatingComponent;



// WEBPACK FOOTER //
// ./app/src/components/StarRating/components/StarRating/index.jsx